module.exports = __webpack_public_path__ + "static/media/client-report-icon.d3baf1f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client-report-icon.svg
// module id = 1021
// module chunks = 1